import axiosInstance from "@/api/axios-instance";

export interface CohortLead {
  found: true;
  response_id: string;
  full_name: string | null;
  email: string | null;
  phone_number: string | null;
  created_at: string;
  converted: boolean; // lead was converted to a user
}

export interface UserCohort {
  as_of: string | null; // the user's created_at (cohort anchor); null if unknown
  region: string | null;
  user_found: boolean;
  // Whether the resolved user already owns an onboarding bundle for the product
  // passed to getUserCohort. Only meaningful when a productId was supplied.
  has_onboarded: boolean;
  full_name: string | null;
  phone: string | null; // the resolved user's phone (for confirmation)
  lead: CohortLead | null; // matching lead info (CRM confirmation)
}

// CRM: resolve a user's pricing cohort from a phone (for building a public
// Choose-a-Bundle link tailored to that user). Pass `productId` to also learn
// whether they've onboarded that product (drives the `has_onboarded` link param).
export async function getUserCohort(
  phone: string,
  region?: string,
  productId?: string,
): Promise<UserCohort> {
  return (
    await axiosInstance.get("/bundle/user-cohort", {
      params: {
        phone,
        ...(region ? { region } : {}),
        ...(productId ? { product_id: productId } : {}),
      },
    })
  ).data;
}

export interface OnboardingBundle {
  id: string;
  name: string;
  amount: number;
  currency: string;
}

// CRM: the onboarding bundle (cohort-resolved via as_of) for a product+region —
// shown alongside the generated Choose-a-Bundle link.
export async function getOnboardingBundle(
  productId: string,
  region: string,
  asOf?: string | null,
): Promise<OnboardingBundle | null> {
  return (
    await axiosInstance.get("/bundle/onboarding-bundle", {
      params: {
        product_id: productId,
        ...(region ? { region } : {}),
        ...(asOf ? { as_of: asOf } : {}),
      },
    })
  ).data;
}
